import html from "html-literal";

export default () => html`
    <div class="homePage">
        <h1 id = "me">Ashley Morgan</h1>
        <h3 id = "whatIDo">Welcome! I enjoy Full Stack Web Development, Security, and solving any coding challenge</h3>
        <h4 id = "enter">Click To Enter</h4>
    </div>
`;